var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("size-" + _vm.size + " " + _vm.iconClass),domProps:{"innerHTML":_vm._s(_vm.iconSvg(_vm.name))}})}
var staticRenderFns = []

export { render, staticRenderFns }